import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Immobiliare } from "assets/icons/immobiliare_color.svg";
import { ReactComponent as Idealista } from "assets/icons/idealista_color.svg";
import { ReactComponent as Wikicasa } from "assets/icons/wikicasa.svg";
import { ReactComponent as Casa } from "assets/icons/casa.svg";
import { ReactComponent as Trovacasa } from "assets/icons/trovacasa.svg";
import { ReactComponent as Mioaffitto } from "assets/icons/mioaffitto.svg";
import { ReactComponent as SearchIcon } from "assets/icons/search.svg";
import { ReactComponent as ArrowBottom } from "assets/icons/arrow_bottom.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import PropertyFilterDropdown from "components/DropDown/PropertyTypeFilterDropdown";
import SearchDropdown from "components/DropDown/SearchDropdown";
import { useMediaQuery } from "react-responsive";
import useSearch from "hooks/useSearch";
import Slider from "react-slick";
import useProperties from "hooks/useProperties";
import ButtonSpinner from "components/Loading/ButtonSpinner";
import { useNavigate } from "react-router";
import { buildResultsPageUrl } from "utils/formatUrl";
import useSearchFilter from "hooks/useSearchFilter";
import { formatLocationName, isObjectEmpty } from "utils/commonUtils";
import { formatPropertyType } from "utils/searchFilter";

const brandMap = [
  { id: 1, icon: Immobiliare, orginalColor: "#256D97" },
  { id: 2, icon: Idealista, orginalColor: "#8F9130" },
  { id: 3, icon: Wikicasa, orginalColor: "#2E79BB" },
  { id: 4, icon: Casa, orginalColor: "#DE062E" },
  { id: 5, icon: Trovacasa, orginalColor: "#00A137" },
  { id: 6, icon: Mioaffitto, orginalColor: "#016AA9" },
];

const IconComponent = ({
  Icon,
  isActive,
  orginalColor,
  isAnimationComplete,
}) => {
  return (
    <Icon
      style={{
        fill: isAnimationComplete
          ? "#333D43"
          : isActive
          ? orginalColor
          : "#333D434A",
        transition: "fill 0.3s ease-in-out",
      }}
      className={`cursor-pointer hover:!fill-[${orginalColor}]`}
    />
  );
};

const HeroSection = () => {
  const {
    searchTerm,
    selectedLocations,
    handleSearchChange,
    selectedPropertyType,
    propertyTypeDetails,
    openSearchDropdown,
    isFilterDropdownOpen,
    toggleFilterDropdown,
    showSearchDropdown,
    handleRemoveLocation,
  } = useSearch();
  const { properties, loading, error, searchProperties } = useProperties();
  const { sortBy } = useSearchFilter();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [activeIndex, setActiveIndex] = useState(-1);
  const [isAnimationComplete, setIsAnimationComplete] = useState(false);
  const repeatCount = 3;
  const animationDuration = 300;
  const buttonRef = useRef(null);

  const sliderSettings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    variableWidth: true,
  };

  const navigation = useNavigate();
  const inputRef = useRef(null); // Ref for the input field

  useEffect(() => {
    let totalDuration = 0;

    for (let repeat = 0; repeat < repeatCount; repeat++) {
      brandMap.forEach((_, index) => {
        setTimeout(() => {
          setActiveIndex(index);
        }, totalDuration + index * animationDuration);
      });
      totalDuration += brandMap.length * animationDuration;
    }

    setTimeout(() => {
      setActiveIndex(-1);
      setIsAnimationComplete(true);
    }, totalDuration + animationDuration);
  }, []);

  const handleSearch = async () => {
    if (selectedLocations.length < 1) return navigation("/research");
    // try {
    // const filters = {
    //   propertyType: formatPropertyType(
    //     selectedPropertyType,
    //     propertyTypeDetails
    //   ),
    //   zipCodes: selectedLocations.map((location) => location.zip),
    //   sortBy: sortBy.value,
    // };

    // const res = await searchProperties(filters);
    // if (res) {
    const queryParams = {
      locationIds: selectedLocations.map((location) => location.id),
      propertyType: selectedPropertyType,
      zipCodes: selectedLocations.flatMap((location) =>
        location.zip.split(",").map((zip) => zip.trim())
      ),
      sortBy: sortBy.label,
      propertyTypeDetails,
    };

    const url = buildResultsPageUrl(queryParams);

    navigation(url);
    // }
    // } catch (error) {
    //   console.log("Search property error: ", error);
    // }
  };

  // auto focus input
  useEffect(() => {
    if (showSearchDropdown && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showSearchDropdown]);

  return (
    <div className="bg-[#ECF0FE] h-auto pb-10 md:pb-[50px] w-full pt-[51px] md:pt-[71px] px-5">
      <div className="mx-auto max-w-[1320px]">
        <h1 className="text-[32px] text-center md:text-start md:text-[37px] lg:text-[45px] font-semibold text-black leading-[1.2] md:leading-[54.46px]">
          Tutti i portali immobiliari
          <span className="text-primary font-bold"> in una sola ricerca</span>
        </h1>
        <p className="text-black max-w-[400px] md:max-w-fit mx-auto md:mx-0 text-center md:text-start mt-[15px] md:mt-2 text-[16px] lg:text-[20px] font-normal md:font-medium leading-[24px] md:leading-[25.2px]">
          Il primo comparatore immobiliare in Italia che scannerizza i portali e
          organizza i risultati della ricerca{" "}
        </p>
        <div className="w-full space-y-[7px] p-5 md:p-0 md:space-y-0 relative md:0  flex flex-col md:flex-row h-auto md:h-[78px] items-center mt-[30px] md:mt-[33px] bg-white rounded-[20px] md:pl-[28px] md:pr-[9px]">
          <div
            ref={buttonRef}
            onClick={(e) => {
              e.stopPropagation();
              toggleFilterDropdown("landingMainFilter");
            }}
            className="w-full md:w-[24%] cursor-pointer lg:w-[27%] select-none h-[48px] border md:border-l-0 md:border-b-0 md:border-t-0  pl-[15px] md:pl-0 rounded-[10px] md:rounded-none border-[#EAECF0] flex items-center md:!border-r-[1px] pr-[20px] md:h-full md:border-[#D9D9D9] space-x-5"
          >
            <p className="text-[16px] text-nowrap lg:text-[20px] font-medium flex-1">
              {selectedPropertyType}
            </p>
            <ArrowBottom
              strokeWidth={2}
              className={`cursor-pointer transition-all duration-[.25s] ease-in-out ${
                isFilterDropdownOpen ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>
          <PropertyFilterDropdown
            style={{
              left: 0,
              top: isMobile ? 63 : 80,
              right: 0,
              maxWidth: 375,
              width: isMobile ? "calc(100% - 20px) !important" : "100%",
            }}
            id="landingMainFilter"
            buttonRef={buttonRef}
          />
          <div className="w-full h-full md:w-[76%] lg:w-[73%] relative space-y-[7px] md:space-y-0 md:flex items-center flex-col md:flex-row justify-between">
            <div className="relative w-full px-[15px] md:px-0 flex-1 md:h-full flex items-center md:mr-[9px] h-[48px] border md:border-none rounded-[10px] md:rounded-none">
              <SearchIcon
                onClick={openSearchDropdown}
                className="md:ml-[22px] cursor-pointer flex-shrink-0 mr-[9px] md:mr-[18px] w-[29px] h-[29px] md:w-[32.07px] md:h-[32.07px] "
              />

              {/* search chip  */}

              {selectedLocations.length > 0 && (
                <div className="flex mr-[12px] px-[9px] cursor-pointer items-center space-x-[11px] bg-[#ECF0FE] max-w-[200px] xs:max-w-[280px] rounded-[5px] border border-primary flex-shrink-0 h-10 md:h-[49px]">
                  <p className="text-primary text-[14px] sm:text-[20px] truncate flex-1 font-extralight ">
                    {selectedLocations.length > 1
                      ? `Milano • ${selectedLocations.length} zone selezionate`
                      : formatLocationName(selectedLocations[0].name)}
                  </p>
                  <div
                    onClick={handleRemoveLocation}
                    className=" w-[16px] h-[16px] min-w-[16px] sm:!w-[22px] sm:min-w-[22px] sm:!h-[22px] rounded-full bg-primary flex items-center justify-center"
                  >
                    <CloseIcon
                      width={10}
                      height={10}
                      className="text-white fill-white"
                    />
                  </div>
                </div>
              )}
              <div
                className="flex-1 h-full flex items-center justify-start"
                onClick={openSearchDropdown}
              >
                <input
                  ref={inputRef}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder={
                    selectedLocations.length > 0 && !showSearchDropdown
                      ? ""
                      : isMobile
                      ? "Inserisci un comune o zona"
                      : "Effettua una nuova ricerca inserendo comune o zona"
                  }
                  className="placeholder:font-normal placeholder:text-[#0000004D] text-[20px] font-medium text-black w-full outline-none border-none bg-transparent"
                />
              </div>
              <SearchDropdown
                dropdonwStyle={{
                  top: isMobile ? 48.3 : 78.2,
                }}
              />
            </div>
            <button
              disabled={loading}
              onClick={handleSearch}
              className="w-full md:w-[140px] flex-shrink-0 disabled:cursor-not-allowed lg:w-[199px] h-[48px] md:h-[60px] flex items-center justify-center rounded-[10px] bg-primary text-white text-[16px] md:text-[20] lg:text-[24px] font-semibold hover:bg-opacity-90 duration-300 ease-in-out"
            >
              {loading ? <ButtonSpinner /> : "Cerca"}
            </button>
          </div>
        </div>
        {!isMobile && (
          <div className="flex items-center space-x-[50px] scroll-smooth scrollbar-hide mt-[30px] md:mt-[52px] justify-between overflow-x-auto">
            {brandMap.map(({ id, icon: Icon, orginalColor }, index) => (
              <div key={id}>
                <IconComponent
                  Icon={Icon}
                  isActive={activeIndex === index}
                  orginalColor={orginalColor}
                  isAnimationComplete={isAnimationComplete}
                />
              </div>
            ))}

            {/* dasktop */}
            <p className="text-[16px] flex-shrink-0 flex-grow-0 font-medium hidden md:block text-[#333D43]">
              E centinaia di altri partner!
            </p>
          </div>
        )}

        {/* Mobile view with Slick Slider */}
        {isMobile && (
          <div className="mt-[30px]">
            <Slider className="max-h-[25px]" {...sliderSettings}>
              {brandMap.map(({ id, icon: Icon, orginalColor }, index) => (
                // <div
                //   className="flex-grow-0 flex-shrink-0 object-contain w-auto pr-[50px]"
                //   key={id}
                // >
                //   <img
                //     src={icon}
                //     alt="Brand Logo"
                //     className="flex-grow-0 cursor-pointer flex-shrink-0 object-contain grayscale-[100%] hover:!grayscale-0"
                //   />
                // </div>
                <div
                  className="flex-grow-0 flex-shrink-0 object-contain w-auto pr-[50px]"
                  key={id}
                >
                  <IconComponent
                    Icon={Icon}
                    isActive={activeIndex === index}
                    orginalColor={orginalColor}
                  />
                </div>
              ))}
            </Slider>
          </div>
        )}
        {/* mobile  */}
        <p className="text-[16px] font-medium flex-shrink-0 flex-grow-0  md:hidden text-center mt-[27px] text-[#333D43]">
          E centinaia di altri partner!
        </p>
      </div>
    </div>
  );
};

export default HeroSection;
